/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  MICROSOFT_AZURE_LINK:
    'https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade',
  CREATE_BOT_FRAMEWORK_LINK: 'https://dev.botframework.com/bots/new',
  MICROSOFT_TEAMS_APP_LINK: 'https://dev.teams.microsoft.com/home',
  learnMoreEndpoint: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-watson-assistant-release-notes'
  ),
  learnMoreTeams: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-microsoft-teams'
  )
};
